import React, { Component } from 'react';
import RegisterBlock from "../modules/RegisterBlock";
import OutageGuarantee from "../modules/OutageGuarantee";
import InlineTextBlocks from "../modules/InlineTextBlocks/InlineTextBlocks";
import Table from "../modules/Table";
import globals from '../globals';
import Hero from "../modules/Hero/Hero";
import HelmetDefault from "../layout/HelmetDefault";
import InternetFormContainer from "../forms/InternetFormContainer/InternetFormContainer";

class InternetWireless extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            inlineTextBlocks: {},
            serviceAgreement: {},
            seoTitle: '',
            seoDescription: '',
			form: {},
			plans: [],
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/internet/business-wireless')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
				<InlineTextBlocks data={this.state.inlineTextBlocks} dataReceived={this.state.dataReceived} />
				<InternetFormContainer
					title={this.state.form.title}
					subTitle={this.state.form.subTitle}
					plans={this.state.plans}
					apiUrl="/api/submit-business-wireless-form"
					submitEvent="businessWirelessFormSubmit"
				/>
                <Table data={this.state.serviceAgreement} image="/images/suitcase-dude.png" />
                <OutageGuarantee />
                <RegisterBlock />
            </div>
        );
    }

}

export default InternetWireless;


// WEBPACK FOOTER //
// ./resources/assets/js/internet/InternetWireless.js